import { Injectable } from "@angular/core";
import { Token } from "./token";
import { TokenService } from "./token.service";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { ConfigService } from "../../services/config.service";

@Injectable({
  providedIn: "root"
})
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor(
    private _configService: ConfigService,
    private _tokenService: TokenService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this._configService.hasAuthConfig()) {
      return next.handle(req);
    }

    const token: Token = new Token(this._tokenService.getToken()),
      authConfig = this._configService.getAuthConfig();

    if (token && token.token != null && !token.isExpired()) {
      req = req.clone({
        headers: req.headers.set(
          authConfig.HeaderName,
          authConfig.HeaderPrefix + " " + token.token
        )
      });
    }

    return next.handle(req);
  }
}
